import { render, staticRenderFns } from "./approvefarmerupdate.vue?vue&type=template&id=49318c57"
import script from "./approvefarmerupdate.vue?vue&type=script&lang=js"
export * from "./approvefarmerupdate.vue?vue&type=script&lang=js"
import style0 from "./approvefarmerupdate.vue?vue&type=style&index=0&id=49318c57&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports